// IMPORT
const THREE = require('three')
require('src/lib/JDLoader.min')
import {loadingManager, load, registerSize} from '../loader'
import {state as gameState} from '../main'
import {config as gameConfig} from '../config'
import {randSign} from '../utils'
// import sounds from '../sounds'
import {TimelineMax, TweenMax, Cubic, SlowMo, CustomEase, Linear} from 'gsap'
import * as STAGES from '../stages'
import raf from '../raf'
import listener from '../listener'
import lerp from 'lerp'
import _ from 'lodash'
import * as clock from '../clock'

let base = require('src/../config').build.assetsPublicPath

// let eliteEase = CustomEase.create('custom', 'M0,0,C0,0,0.02,0.074,0.088,0.136,0.14,0.183,0.178,0.026,0.398,0.026,0.858,0.026,0.91,0.226,0.92,0.402,0.933,0.642,1,1,1,1')
let eliteEase = CustomEase.create('custom', 'M0,0,C0,0,0.02,0.074,0.088,0.136,0.14,0.183,0.129,-0.059,0.332,0.026,0.952,0.286,1,1,1,1')


// ****************************************************************
//
// GEOMETRY
//
// ****************************************************************
const models = {
  male: {
    url: require('assets/models/runner/male.json'),
    size: 219295
  },
  female: {
    url: require('assets/models/runner/female.json'),
    size: 204985
  },
  player: {
    url: require('assets/models/runner/intro_runner.jd'),
    size: 103183,
    type: 'jd'
  }
}
for (let key in models) {
  let model = models[key]
  registerSize(model.url, model.size)
  if (model.type === 'jd') {
    load(model.url, new THREE.JDLoader(loadingManager), (results)=> {
      model.geometry = results[0].geometries[0]
      model.geometry.computeFaceNormals()
      model.geometry.computeVertexNormals()
    })
  } else {
    load(model.url, new THREE.JSONLoader(loadingManager), (results)=> {
      model.geometry = results[0]
      model.geometry.computeFaceNormals()
      model.geometry.computeVertexNormals()
    })
  }
}



// ****************************************************************
//
// MATERIAL
//
// ****************************************************************
const textures = {
  male1: {
    url: require('assets/models/runner/male1.jpg'),
    size: 40160
  },
  male2: {
    url: require('assets/models/runner/male2.jpg'),
    size: 40270
  },
  male3: {
    url: require('assets/models/runner/male3.jpg'),
    size: 40451
  },
  female1: {
    url: require('assets/models/runner/female1.jpg'),
    size: 63260
  },
  female2: {
    url: require('assets/models/runner/female2.jpg'),
    size: 35650
  },
  female3: {
    url: require('assets/models/runner/female3.jpg'),
    size: 35076
  },
  elite1: {
    url: require('assets/models/runner/elite1.jpg'),
    size: 39235
  },
  elite2: {
    url: require('assets/models/runner/elite2.jpg'),
    size: 38034
  },
  elite3: {
    url: require('assets/models/runner/elite3.jpg'),
    size: 37502
  },
  player1: {
    url: require('assets/models/runner/intro_runner.jpg'),
    size: 150525
  }
}
for (let key in textures) {
  let texture = textures[key]
  let material = new THREE.MeshLambertMaterial({
    // skinning: true,
    vertexColors: THREE.FaceColors,
    morphTargets: true,
    transparent: true,
    alphaTest: 0.1
  })


  texture.material = material
  let url = texture.url
  registerSize(url, texture.size)
  load(url, new THREE.TextureLoader(loadingManager), (results)=> {
    texture.material.map = results[0]

    if (texture.bump) {
      texture.material.bumpMap = results[0]
      texture.material.bumpScale = texture.bump
    }

    texture.material.needsUpdate = true
  })
}




// ****************************************************************
//
// SOUNDS
//
// ****************************************************************
const sounds = {
  // stepL0: {url: require('src/assets/sounds/fx/steps/stepL1.mp3'),           x: -0.5, y: -2.25, size: 10000, volume: 2.5},
  // stepL1: {url: require('src/assets/sounds/fx/steps/stepL2.mp3'),           x: -0.5, y: -2.25, size: 10000, volume: 2.5},
  // stepL2: {url: require('src/assets/sounds/fx/steps/stepL3.mp3'),           x: -0.5, y: -2.25, size: 10000, volume: 2.5},
  // stepR0: {url: require('src/assets/sounds/fx/steps/stepR1.mp3'),           x:  0.5, y: -2.25, size: 10000, volume: 2.5},
  // stepR1: {url: require('src/assets/sounds/fx/steps/stepR2.mp3'),           x:  0.5, y: -2.25, size: 10000, volume: 2.5},
  // stepR2: {url: require('src/assets/sounds/fx/steps/stepR3.mp3'),           x:  0.5, y: -2.25, size: 10000, volume: 2.5},
  // breath0: {url: require('src/assets/sounds/fx/breathing/breathing1.mp3'),  x:  0, y:  2.25, size: 10000, volume: 2.5, positional: false},
  // breath1: {url: require('src/assets/sounds/fx/breathing/breathing3.mp3'),  x:  0, y:  2.25, size: 10000, volume: 2.5, positional: false},
  // breath2: {url: require('src/assets/sounds/fx/breathing/breathing4.mp3'),  x:  0, y:  2.25, size: 10000, volume: 2.5, positional: false},
  // breath3: {url: require('src/assets/sounds/fx/breathing/breathing5.mp3'),  x:  0, y:  2.25, size: 10000, volume: 2.5, positional: false},
  // breath4: {url: require('src/assets/sounds/fx/breathing/breathing6.mp3'),  x:  0, y:  2.25, size: 10000, volume: 2.5, positional: false}
}
for (let key in sounds) {
  let sound = sounds[key]
  registerSize(sound.url, sound.size)
  load(sound.url, null, (results)=> {
    sound.buffer = results[0]
  })
}



// ****************************************************************
//
// CHECK LOADED
//
// ****************************************************************
let loaded = false









// ****************************************************************
//
// CLASS
//
// ****************************************************************
export default class Runner {

  constructor (config) {


    // STATE
    this.state = Object.assign({
      initialized: false,
      models: models,
      textures: textures,
      isPlayer: false,
      isElite: false,
      isPacer: false,
      type: 'male',
      idx: 0,
      materialIdx: null,
      path: null,
      color: 0xEB0033,
      baseVelocity: 1,
      distance: 1,
      distanceStart: 1,
      currDistance: 1,
      swipeVelocity: 0,
      swipeVelocityMax: 0,
      velocity: 0,
      sps: 0,
      spsMax: 0,
      px: 0,
      offset: 0,
      sounds: sounds,
      minVel: 0,
      maxVel: 0,
      multiplyVelocity: 0,
      addVelocity: 0,
      autoUpdateState: true
    }, config)
    this.initialState = this.state

    this.state.currDistance = this.state.distance

    if (this.state.materialIdx === null) {
      this.state.materialIdx = this.state.idx % 3
    }

    // MESH
    this.mesh = new THREE.Object3D()
    this.mesh.name = 'runner'

    // AUDIO
    this.audio = {}
    for (let key in this.state.sounds) {
      let audio

      // NON-POSITIONAL
      if (this.state.sounds[key].positional === false) {
        audio = new THREE.Audio(listener)

      // POSITIONAL
      } else {
        audio = new THREE.PositionalAudio(listener)
        audio.setRefDistance(this.state.sounds[key].distance || 1)
        audio.position.x = this.state.sounds[key].x || 0
        audio.position.y = this.state.sounds[key].y || 0
      }
      audio.setLoop(false)
      this.audio[key] = audio
      this.mesh.add(this.audio[key])
    }

  }



  // **********************************************************************
  //
  // INIT
  //
  // **********************************************************************
  checkAllLoaded = ()=> {

    // Check Models
    for (let key in this.models) {
      if (!models[key].geometry) return false
    }

    // Check Textures
    for (let key in this.textures) {
      if (!textures[key].material.map) return false
    }

    // Check Sounds
    for (let key in this.state.sounds) {
      if (!this.state.sounds[key].buffer) return false
    }

    // init
    loaded = true

    this.init()
    return true
  }

  init () {
    if (this.state.initialized) return
    this.state.initialized = true
    this.initTexture()
    if (models[this.state.type].type === 'jd') {
      this.initJdModel()
    } else {
      this.initModel()
    }
    this.initAudio()
    this.updatePosition()
  }

  initJdModel () {
    // GEOMETRY
    let geometry
    switch (this.state.type) {
      case 'female':
        geometry = models.female.geometry
        break
      case 'player':
        geometry = models.player.geometry
        break
      default:
        geometry = models.male.geometry
        break
    }


    // MATERIAL
    const materialKey = `${this.state.type}${this.state.materialIdx + 1}`
    let material = textures[materialKey].material
    // this.material = material
    this.material = material.clone()


    // MESH
    this.model = new THREE.SkinnedMesh(geometry, this.material)
    this.model.castShadow = true
    let scale = window.Maf.randomInRange(0.0220, 0.0230)
    this.model.scale.setScalar(scale)
    // this.model.receiveShadow = true
    // this.model.scale.setScalar(0.0225)
    // this.model.scale.setScalar(gameConfig.worldScale)
    // this.model.scale.setScalar(0.0225)
    if (!this.state.isPlayer) {
      this.model.position.x = this.state.offset
    }
    this.model.castShadow = true
    this.mesh.add(this.model)


    // ANIMATION
    this.mixer = new THREE.AnimationMixer(this.model)
    let clips = geometry.animations
    this.actions = {} // IDLE, WARMUP, READY, RUN, INTRO
    for (let clip of clips) {
      let action = this.mixer.clipAction(clip)
      this.actions[clip.name] = action
      action.play()
      // action.fadeOut(0)
    }
    if (!this.isPlayer) {
      this.currAction = this.actions['ready']
      // this.fadeInAnim('run', 0, Math.random() * 4)
    } else {
      this.currAction = this.actions['intro']
      this.currAction.setLoop(THREE.LoopOnce)
    }
    this.mixer.update(0)
  }


  initModel () {

    // GEOMETRY
    let geometry
    switch (this.state.type) {
      case 'female':
        geometry = models.female.geometry
        break
      case 'player':
        geometry = models.player.geometry
        break
      default:
        geometry = models.male.geometry
        break
    }


    // MATERIAL
    const materialKey = `${this.state.type}${this.state.materialIdx + 1}`
    let material = textures[materialKey].material
    // this.material = material
    this.material = material.clone()


    // MESH
    this.model = new THREE.SkinnedMesh(geometry, this.material)
    this.model.castShadow = true
    this.model.scale.setScalar(0.0225)
    // this.model.scale.setScalar(gameConfig.worldScale)
    // this.model.scale.setScalar(0.0225)
    if (!this.state.isPlayer) {
      this.model.position.x = this.state.offset
    }
    this.mesh.add(this.model)


    // ANIMATION
    this.mixer = new THREE.AnimationMixer(this.model)
    // let clips = geometry.animations
    let clip = THREE.AnimationClip.CreateFromMorphTargetSequence(
      'gallop',
      geometry.morphTargets,
      30
    )
    this.actions = {
      run: this.mixer.clipAction(clip)
    }

    // this.actions = {} // IDLE, WARMUP, READY, RUN, INTRO
    // for (let clip of clips) {
    //   let action = this.mixer.clipAction(clip)
    //   this.actions[clip.name] = action
    //   action.play()
    //   // action.fadeOut(0)
    // }
    // console.log(111, this.actions)
    if (!this.isPlayer) {
      // this.currAction = this.actions['ready']
      this.currAction = this.actions['run']
      // this.fadeInAnim('run', 0, Math.random() * 4)
    } else {
      // this.currAction = this.actions['intro']
      // this.currAction.setLoop(THREE.LoopOnce)
    }
    this.mixer.update(0)

  }

  initTexture () {}

  initAudio () {
    // console.log(111, 'initAudio', this.audio)
    for (let key in this.audio) {
      let audio = this.audio[key]
      audio.setBuffer(this.state.sounds[key].buffer)
      audio.setVolume(0.001)
      audio.play()
      // audio.stop()
      // audio.setVolume(this.state.sounds[key].volume || 1)
    }
  }




  // **********************************************************************
  //
  // UPDATE
  //
  // **********************************************************************

  updateState (delta) {

    let min = Math.max(gameState.velocity.now + 1, this.state.minVel)
    min = Math.min(min, this.state.maxVel)
    this.state.minVel = min

    let vel = gameState.velocity.now * this.state.multiplyVelocity + this.state.addVelocity
    vel = Math.max(vel, this.state.minVel)
    vel = Math.min(vel, this.state.maxVel)
    this.state.velocity = vel

    // CALC POSITION
    this.state.px += this.state.velocity * delta
    let progress = this.state.px / gameConfig.totalPx
    this.state.distance = this.state.distanceStart + (progress * gameConfig.numLaps)
  }

  updatePosition () {

    if (!this.model) return

    this.state.currDistance += (this.state.distance - this.state.currDistance) / 5

    const pt1 = this.state.path.getPointAt(this.state.currDistance % 1)
    this.mesh.position.set(pt1.x, pt1.y, pt1.z)

    const pt2 = this.state.path.getPointAt((this.state.currDistance + 0.005) % 1)
    this.mesh.lookAt(pt2)
  }

  updateAnimation = (delta)=> {
    if (this.mixer) {
      // console.log(this.state.type)
      let weight = (this.state.velocity / gameConfig.velocityMax) * 0.07
      weight = Math.min(weight, 1.03)
      this.mixer.timeScale = 0.96 + weight
      // this.mixer.timeScale *= 0.5
      // this.mixer.setEffectiveTimeScale(0.95 + weight)
      this.mixer.update(delta / 1000)
    }
  }

  update = (delta)=> {

    // console.log('udpate')

    // if (!this.model) {
    //   return this.checkAllLoaded()
    // }

    if (!gameState) return


    // THROTTLED
    // if (this.state.isPlayer) {
    //   if (gameState.stage > STAGES.INTRO && this.state.autoUpdateState) {
    //     this.updateState(delta)
    //   }
    //   this.updatePosition()
    // } else {
    //   this.updateStateThrottled(delta)
    //   this.updatePositionThrottled()
    // }

    // THROTTLE POSITION ONLY
    // if (gameState.stage > STAGES.INTRO && this.state.autoUpdateState) {
    //   this.updateState(delta)
    // }
    // if (this.state.isPlayer) {
    //   this.updatePosition()
    // } else {
    //   this.updatePositionThrottled()
    // }

    // NOT THROTTLED
    // console.log('update', this.state.type)
    if (gameState.stage > STAGES.INTRO && this.state.autoUpdateState) {
      this.updateState(delta)
    }
    this.updatePosition()





    // ANIMATION
    this.updateAnimation(delta)

  }





  // **********************************************************************
  //
  // METHODS
  //
  // **********************************************************************
  start = ()=> {
    // console.log('start', this.state.type)

    if (!this.state.initialized) this.init()

    this.mesh.visible = true
    this.isPlaying = true
    // this.fadeInAnim('run', 1, Math.random() * 3)
    if (this.model) {
      this.fadeInAnim('run', 0, Math.random() * 3)
    }
    // this.audio.stepL1.play()

    // TweenMax.to(this.state, 0.5, {
    //   sps: this.state.spsMax,
    //   swipeVelocity: this.state.swipeVelocityMax,
    //   ease: Cubic.easeIn
    // })

    // console.log('here')
    // TweenMax.to(this.state, 2.6 + this.state.idx * 0.1, {
    //   addVelocity: 14 + this.state.idx * 0.5,
    //   ease: SlowMo.ease.config(0.9, 0.8, true)
    // })
  }


  stop = ()=> {
    this.isPlaying = false
  }


  reset = ()=> {
    this.state = Object.assign({}, this.initialState)
    this.updatePosition()
    for (let key in this.actions) {
      let action = this.actions[key]
      // console.log(1112, action)
      action.play()
      action.fadeOut()
    }
  }

  fadeInAnim = (key, time, delay)=> {
    let action = this.actions[key]
    if (!action) return
    action.startAt(this.mixer.time - delay)
    action.crossFadeFrom(this.currAction, time)
    this.currAction = action
  }

  turnElite = (idx)=> {
    // this.state.autoUpdateState = false
    // this.state.addVelocity = 0
    this.state.isElite = true
    this.material.map = textures[`elite${idx + 1}`].material.map
    this.material.needsUpdate = true

  }



  fadeTo = (opacity, time = 1)=> {
    this.model.visible = true
    TweenMax.to(this.material, time, {
      opacity: opacity,
      ease: Cubic.easeOut,
      onUpdate: ()=> {
        this.material.needsUpdate = true
      },
      onComplete: ()=> {
        if (this.material.opacity === 0) {
          this.mesh.visible = false
        }
      }
    })
  }


}






// WEBPACK FOOTER //
// ./src/components/game/runner/runner-morph.js